module.exports = __webpack_public_path__ + "img/长安大学.c6b52f33.png";